import { Close } from "@mui/icons-material";
import { Divider, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import {
  addSpecifications,
  updateSpecifications,
} from "../../Services/Specifications";
import FormSelectCategories from "../SpecificationTypes/FormSelectCategories";
import FormSelectSpecificationType from "./FormSelectSpecificationType";
import CustomInput from "../../shared/CustomInput2";
import CustomButton from "../../shared/CustomButton2";
import { useParams } from "react-router-dom";

const AddSpecifications = ({ open, setOpen, rowData, setRowData }) => {
  const { id } = useParams();
  const [category, setCategory] = useState();
  const [specificationType, setSpecificationType] = useState();
  const [specificationName, setSpecificationName] = useState("");
  const client = useQueryClient();

  const handleClose = () => {
    setOpen(false);
    setSpecificationName("");
    setRowData();
  };

  const { mutate: addSpecificationMutation } = useMutation(addSpecifications, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        client.invalidateQueries(`specifications-${id}`);
        handleClose();
      } else {
        toast.error(res?.data?.message);
      }
    },
  });

  const { mutate: updateSpecificationMutation } = useMutation(
    updateSpecifications,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          client.invalidateQueries(`specifications-${id}`);
          handleClose();
        } else {
          toast.error(res?.data?.message);
        }
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!rowData) {
      addSpecificationMutation({
        product_specification: specificationType,
        specification_type: specificationName,
      });
    } else {
      updateSpecificationMutation({
        specification_id: rowData.id,
        product_specification: specificationType,
        specification_type: specificationName,
      });
    }
  };

  useEffect(() => {
    if (rowData) {
      setSpecificationName(rowData.specification);
    }
  }, [rowData]);

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="absolute w-2/5 -translate-x-1/2 -translate-y-1/2 bg-white rounded-md top-1/2 left-1/2">
        <div className="relative">
          <Close
            className="absolute cursor-pointer right-4 top-4"
            onClick={handleClose}
          />
          <div className="p-4 text-2xl font-semibold text-center">
            {rowData ? "Update" : "Add"} Specifications
          </div>
          <Divider />
          <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4">
            <FormSelectCategories
              category={category}
              setCategory={setCategory}
              categoryName={rowData?.category_name}
            />
            <FormSelectSpecificationType
              specificationType={specificationType}
              setSpecificationType={setSpecificationType}
              categoryId={category}
              specificationTypeName={rowData?.specification_type}
            />
            <CustomInput
              label="Specification Name"
              value={specificationName}
              onChange={(e) => setSpecificationName(e.target.value)}
            />
            <div className="flex justify-end">
              <CustomButton type="submit" variant="outlined">
                {rowData ? "Update" : "Add"}
              </CustomButton>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddSpecifications;
